var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",attrs:{"id":"app"}},[_c('div',{staticClass:"main-panel"},[(!_vm.noHeader)?_c('app-header'):_vm._e(),_c('div',{staticClass:"content pl-30",attrs:{"id":"content"}},[_c('router-view'),(_vm.hasIphoneContainer)?_c('iphone-frame-preview'):_vm._e()],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }